import * as GlobalScope from '/opt/build/repo/docs-www/src/globalReferences.js';
          export const Scope = GlobalScope;
          /**
 * CAUTION: Do not delete this file.
 * In build process there will be added imports to user defined global references
 */



// WEBPACK FOOTER //
// ./~/@brainhubeu/gatsby-docs-kit/src/globalReferences.js